import { addBlankDiv } from './add-blank-div.js'

const detectMobileWidth = () => {
	const element = document.querySelector('.mobile-width-detect')
	if (!element) {
		addBlankDiv('mobile-width-detect')
		return detectMobileWidth()
	}

	const style = getComputedStyle(element)
	const { position } = style
	return position === 'relative' // <768px
}

export const detectSmallScreenWidth = () => {
	const element = document.querySelector('.mobile-width-detect')
	if (!element) {
		addBlankDiv('mobile-width-detect')
		return detectSmallScreenWidth()
	}

	const style = getComputedStyle(element)
	const { position } = style
	return position === 'fixed' // <992px && >767px
}

export const detectMiddleScreenWidth = () => {
	const element = document.querySelector('.mobile-width-detect')
	if (!element) {
		addBlankDiv('mobile-width-detect')
		return detectMiddleScreenWidth()
	}

	const style = getComputedStyle(element)
	const { position } = style
	return position === 'absolute' // >= 992px
}

export default detectMobileWidth
